export function isSameChain(fromChain: string, currentChain: string): boolean {
    return fromChain === currentChain;
}

export function isNumeric(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
